import { connect } from 'react-redux';
import PersonaCreatorClusterSettings from './PersonaCreatorClusterSettings';
import * as insight360Actions from '../../../actions/insight360Actions';

const mapStateToProps = state => {
  return {
    token: state.login.loginResponse.data.token,
    uid: state.login.loginResponse.data.uid,
    activeAccountId: state.account.activeAccountId,
    segmentCount: state.insight360.personaCreator.clusterSegments.segmentCount,
    attitudesList:
      state.insight360.personaCreator.clusterSegments.attitudesList,
    clusterStatExpressions:
      state.insight360.personaCreator.clusterSegments.clusterStatExpressions,
    selectedExpressionObject:
      state.insight360.personaCreator.clusterSegments.selectedExpressionObject,
    personaLabels: state.insight360.personaCreator.header !== undefined ?
    state.insight360.personaCreator.header.label : '',
    personaExpressions: state.insight360.personaCreator.header !== undefined ?
    state.insight360.personaCreator.header.expression : '',
    productNo: state.study.insight360study.pn,
    attitudinalTemplate:
      state.insight360.personaCreator.clusterSegments
        .defaultAttitudinalTemplate,
    defaultExpression:
      state.insight360.personaCreator.clusterSegments.defaultExpression,
    defaultExpressionObject:
      state.insight360.personaCreator.clusterSegments.defaultExpressionObject,
    selectedAttitudinalTemplate:
      state.insight360.personaCreator.clusterSegments
        .selectedAttitudinalTemplate,
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;
  const { getPersonaCreatorProfilesData } = ownProps;

  const fetchClusterStatementsData = () => {
    dispatch(
      insight360Actions.fetchClusterStatements(
        stateProps.token,
        stateProps.uid,
        stateProps.activeAccountId,
        stateProps.productNo,
      ),
    );
  };

  const createClusterSegments = (
    segmentCount,
    clusterStatExpressions,
    selctedExpressionObject,
    selectedAttitudinal,
  ) => {
    const clusterSegmentsParam = {
      token: stateProps.token,
      uid: stateProps.uid,
      accountId: stateProps.activeAccountId,
      personaLabels: stateProps.personaLabels,
      personaExpressions: stateProps.personaExpressions,
    };
    dispatch(
      insight360Actions.createClusterSegments(
        clusterSegmentsParam,
        segmentCount,
        clusterStatExpressions,
        selctedExpressionObject,
        selectedAttitudinal,
      ),
    ).then(response => {
      if (response) {
        if (segmentCount > 3) {
          dispatch(insight360Actions.setSegmentScreen(true));
        } else {
          getPersonaCreatorProfilesData();
        }
      }
    });
  };

  const saveAttitudinalTemplate = (data, selctedExpressionObject) => {
    dispatch(
      insight360Actions.saveAttitudinalTemplate(
        stateProps.token,
        stateProps.uid,
        stateProps.activeAccountId,
        stateProps.productNo,
        data,
        selctedExpressionObject,
      ),
    );
  };

  return Object.assign({}, stateProps, ownProps, {
    fetchClusterStatementsData,
    createClusterSegments,
    saveAttitudinalTemplate,
  });
};
/**
 *  Sends functions to component
 */
export default connect(
  mapStateToProps,
  null,
  mergeProps,
)(PersonaCreatorClusterSettings);
